import React, { Component } from 'react';
import { Cascader } from 'antd';
import $ from '../../common/AjaxRequest';
import API_URL from '../../common/url';

class CascaderCity extends Component {
    state = {
        options: [],
    }

    componentDidMount() {
        this.queryData(0, res => {
            const { datas = [] } = res;
            const options = datas.map(d => ({
                value: d.regionId,
                label: d.regionName,
                parentId: d.parentId,
                isLeaf: false,
            }));
            this.setState({ options }, () => {
                const { value = [] } = this.props;
                const [ provinceId, cityId ] = value;
                if (cityId) {
                    const province = options.find(i => i.value == provinceId);
                    this.loadData([province]);
                }
            });
        });
    }

    queryData = (parentId, func) => {
        const options = {
            method: 'POST',
            url: API_URL.common.arealist,
            data: { parentId },
            dataType: 'json',
            doneResult: func
        };
        $.sendRequest(options);
    }

    onChange = (value, selectedOptions) => {
        this.props.onChange(value, selectedOptions);
    }

    loadData = (selectedOptions) => {
        const targetOption = selectedOptions[selectedOptions.length - 1];
        targetOption.loading = true;

        this.queryData(targetOption.value, res => {
            targetOption.loading = false;
            const { datas = [] } = res;
            targetOption.children = datas.map(d => ({
                value: d.regionId,
                label: d.regionName,
            }));
            this.setState({ options: [...this.state.options] });
        });
    }

    render() {
        const { options } = this.state;
        const { style, value, placeholder, className = '' } = this.props;
        return (
            <Cascader
                style={style}
                value={value}
                className={className}
                placeholder={placeholder || '请选择'}
                options={options}
                loadData={this.loadData}
                onChange={this.onChange}
                changeOnSelect
            />
        );
    }
}

export default CascaderCity;



// WEBPACK FOOTER //
// ./src/components/common/CascaderCity.js